import styled from 'styled-components';

export const ContainerListShedules = styled.div`
  max-height: 500px;
  overflow: auto;
`;
